import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import { useApi } from '../../util/lib';
import HtmlHead from '../UI/Head/HtmlHead';

import css from './RpryShrtly.module.css';

export const RpryShortly = () => {
  const [pristine, setPristine] = useState(true)
  const [error, setError] = useState()
	const api = useApi();
  const { code } = useParams();
  useEffect(() => {
    const parseShortly = async () => {
      try {
        if (!pristine) return
        setPristine(false)
        const response = await api({
          method: 'get',
          responseType: 'json',
          url: `/sdk/shrtly/${code}`,
        });
        console.log(response.data)
        if (response.data && response.data.originalUrl) {
          window.location.href = response.data.originalUrl;
        } else {
          throw new Error('No URL found');
        }
      } catch (error) {
        console.error(error)
        setError(error)
      }
    }
    parseShortly();
  }, [api, code, pristine])
  return (
    <>
      <HtmlHead repairy />

      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh'
      }}>
        {error && (
          <p>
            Opps! Seems like we cant provide you a service now. 
            Please contact support if problem persists
          </p>
        )}
        {!error && (
          <img
            alt='rpry-icon'
            src='/rpry-icon.svg'
            className={css.RpryLogo} />
        )}
      </div>
    </>
  );
}
